import { NoPayload } from '../commonPayloadTypes';

export enum PortalHelpEvents {
    ClickDownloads = 'ResourceCenter.Open',
}

export interface PortalHelpEventMap {
    [PortalHelpEvents.ClickDownloads]: NoPayload;
}
